var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 13.334C3.5 13.0578 3.72386 12.834 4 12.834L12 12.834C12.2761 12.834 12.5 13.0578 12.5 13.334C12.5 13.6101 12.2761 13.834 12 13.834L4 13.834C3.72386 13.834 3.5 13.6101 3.5 13.334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64775 11.0196C7.84301 11.2148 8.15959 11.2148 8.35486 11.0196L10.6882 8.68624C10.8835 8.49097 10.8835 8.17439 10.6882 7.97913C10.4929 7.78387 10.1763 7.78387 9.98108 7.97913L8.5013 9.45891V2.66602C8.5013 2.38987 8.27744 2.16602 8.0013 2.16602C7.72516 2.16602 7.5013 2.38987 7.5013 2.66602V9.45891L6.02152 7.97913C5.82626 7.78387 5.50968 7.78387 5.31442 7.97913C5.11915 8.17439 5.11915 8.49097 5.31442 8.68624L7.64775 11.0196Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadw);
export default __webpack_public_path__ + "static/media/downloadw.1f6411bd04cfd8c7ba05dd33e7af4af6.svg";
export { ForwardRef as ReactComponent };